module.exports = __webpack_public_path__ + "static/media/barry@3x.798007bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/barry@3x.png
// module id = 214
// module chunks = 1